angular.
module("dx.webapp.api").
factory("dxApiV1Nodes", function apiV1NodesService(
	$http,

	DxSAMLIdentityProvider
) {
	"use strict";

	var baseUrl = "/api/v1/nodes/";

	function samlIdentityProviderGet(nodeId) {
		return $http.get(samlIdentityProviderUrl(nodeId)).then(createIdentityProvider);
	}

	function samlIdentityProviderPut(nodeId, isEnabled, entityId, unitId) {
		var data = {
			isEnabled: isEnabled,
		};

		if (entityId) {
			data.entityId = entityId;
		}

		if (unitId) {
			data.unitId = unitId;
		}

		return $http.put(samlIdentityProviderUrl(nodeId), data).then(createIdentityProvider);
	}

	function samlIdentityProviderDelete(nodeId) {
		return $http.delete(samlIdentityProviderUrl(nodeId));
	}

	function samlIdentityProviderUrl(nodeId) {
		return baseUrl + nodeId + "/saml/identityproviders";
	}

	function createIdentityProvider(response) {
		if (response.data) {
			response.data = new DxSAMLIdentityProvider(response.data);
		}

		return response;
	}

	function getSkolonId(id) {
		return $http.get("/api/v1/nodes/" + id + "/skolonid");
	}

	function setSkolonId(id, skolonId) {
		return $http.put("/api/v1/nodes/" + id + "/skolonid", {skolonId: skolonId});
	}

	function removeSkolonId(id) {
		return $http.delete("/api/v1/nodes/" + id + "/skolonid");
	}

	return {
		saml: {
			identityProviders: {
				get: samlIdentityProviderGet,
				put: samlIdentityProviderPut,
				delete: samlIdentityProviderDelete,
				url: samlIdentityProviderUrl,
			},
		},
		skolonid: {
			get: getSkolonId,
			put: setSkolonId,
			delete: removeSkolonId,
		},
	};
});
